import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "app/pages/Auth/authSelectors";

import { connect } from "react-redux";

const PrivateRoute = ({ children, authPath, isAuthenticated }) => {
	const location = useLocation();
	return isAuthenticated ? (
		<>{children}</>
	) : (
		<Navigate
			replace
			to={{
				pathname: authPath,
				search: `?onauthsuccess=${location.pathname}`,
			}}
		/>
	);
};

function mapStateToProps(state) {
	return { isAuthenticated: isAuthenticated(state) };
}

export default connect(mapStateToProps)(PrivateRoute);

PrivateRoute.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired,
	authPath: PropTypes.string,
};
